"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedFulfillmentResponseWithCount = exports.mockedFulfillmentResponse = exports.mockedFulfillmentUpdateRequest = exports.mockedFulfillmentCreateRequest = void 0;
const date_util_1 = require("../../utils/date.util");
exports.mockedFulfillmentCreateRequest = {
  title: 'ChinaDivision',
  isActive: true
};
exports.mockedFulfillmentUpdateRequest = {
  title: 'ChinaDivision',
  isActive: false
};
exports.mockedFulfillmentResponse = {
  id: 1,
  title: 'ChinaDivision',
  balance: 1000,
  isActive: true,
  createdAt: date_util_1.takeDaysFromNow(),
  updatedAt: null
};
exports.mockedFulfillmentResponseWithCount = {
  items: [exports.mockedFulfillmentResponse],
  count: 1
};